import api from "./index";

export const stagesAPI = {
  getAll: (params) => api.get("/stages", { params }),
  getById: (id) => api.get(`/stages/${id}`),
  create: (data) => api.post("/stages", data),
  update: (id, data) => api.put(`/stages/${id}`, data),
  delete: (id) => api.delete(`/stages/${id}`),
  complete: (id) => api.put(`/stages/${id}/complete`),
  getTasks: (id) => api.get(`/stages/${id}/tasks`),
  getBudget: (id) => api.get(`/stages/${id}/budget`),
};
